import WarehouseListComponent from "./WarehouseListComponent";

const WarehouseOnboardComponent = () => {
  return (
    <>
      <WarehouseListComponent />
    </>
  );
};
export default WarehouseOnboardComponent;
